import React from 'react';
import ReactDOM from 'react-dom/client';
import DisplayApp from './DisplayApp';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<DisplayApp />);